import * as React from 'react';
import { canWriteWorkspaceAsset } from '../selectors';
import { useAccessContext } from './use-access-context';

/**
 * Returns a predicate for whether the user may write to a given asset, scoped
 * by the asset's own workspace rather than the one it was reached through.
 *
 * While the access context is unresolved the predicate answers `true`: the PDP
 * fetches `me` once and app-wide, so an unresolved context on a hovered tile is
 * far rarer than the flicker that disabling-by-default would show every user.
 * Once the query has settled without a context, though, there is nothing left
 * to wait for and no grant to read, so the answer is `false`. The backend
 * rejects an unauthorized write regardless.
 */
export function useCanWriteWorkspaceAsset() {
  const { me, isSettled } = useAccessContext();

  return React.useCallback(
    (asset: { workspace_id?: string | null }) => {
      if (!isSettled) {
        return true;
      }
      return !!me && canWriteWorkspaceAsset(me, asset.workspace_id);
    },
    [me, isSettled],
  );
}
